<template>
    <form @submit="submitForm" class="c-single-field-prompt-form" novalidate>
        <div class="form-group">
            <label :for="inputId" class="col-form-label col-form-label-lg">{{ translations.label }}</label>

            <div class="input-group">
                <input
                    ref="singleFieldInput"
                    :id="inputId"
                    class="form-control form-control-lg"
                    :class="{ 'is-invalid': isInvalid }"
                    :placeholder="translations.placeholder" 
                    :min="config.minValue" 
                    :max="config.maxValue" 
                    v-model="fieldValue"
                    required />

                <div class="input-group" :aria-hidden="!isInvalid" :aria-describedby="inputId" role="alert">
                    <div class="invalid-feedback">{{ translations.validation }}</div>
                </div>
            </div>
        </div>

        <button type="submit" class="btn btn-round btn-lg btn-danger">{{ translations.submit }}</button>
    </form>
</template>

<script>
    import idMixin from '@/mixins/aha-id';
    import registerEvent from '@/resources/register-event.js';
    import pageGoalsMixin from '@/mixins/page-goals';

    export default {
        mixins: [idMixin, pageGoalsMixin],
        inject: ['EventBus'],
        props: {
            translations: {
                type: Object,
                required: true
            },
            config: {
                type: Object,
                required: true
            },
            eventText: {
                type: String,
                default: ""
            },
            eventItemId: {
                type: String
            },
            goals: {
                type: String
            }
        },
        data() {
            return {
                isInvalid: false,
                fieldValue: null
            };
        },
        mounted() {
            this.$nextTick(() => {
                this.EventBus.$emit('registerInput', this.config.currentKey, this.$refs.singleFieldInput);
                 
            });
        },
        methods: {
            submitForm(evt) {
                const value = parseInt(this.fieldValue, 10);

                evt.preventDefault();

                if((isNaN(value) || typeof value !== 'number') || (value < this.config.minValue || value > this.config.maxValue)) {
                    this.isInvalid = true;
                } else {
                    const lowerBound = (this.config.targetValue.length) ? this.config.targetValue[0] : this.config.targetValue;
                    const upperBound = (this.config.targetValue.length) ? this.config.targetValue[1] : this.config.targetValue;

                    this.isInvalid = false;

                    // Trigger Page Goals (mixins - pageGoalsMixin)
                    this.triggerPageGoals(this.goals);

                    // Send the analytics request
                    registerEvent.post(this.$props.eventItemId, this.$props.eventText + ' $$Response$$ ' + value);

                    // If we have an input saved for this step, use it's values to determine the step
                    if(value > upperBound) {
                        this.EventBus.$emit('stepTrigger', this.config.greaterKey);
                    } else if(value < lowerBound) {
                        this.EventBus.$emit('stepTrigger', this.config.lessKey);
                    } else {
                        this.EventBus.$emit('stepTrigger', this.config.targetKey);
                    }
                }
            }
        },
        computed: {
            inputId: function() {
                return this.safeId('_AHA_field-prompt_');
            }
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/app/components/aha-single-field-prompt-form.vue